import React from 'react';
import { ExpressionSettingsLineType } from '../Chart/interfaces';
import RollingControlDisplay from './RollingControlDisplay';
import { RollingDisplaySize } from './types';
import { RollingControlFunction } from '../../utils/apollo/graphqlSchema';
import { measureRollingControlLookup } from '../../utils/builder/rollingControl';

interface IProps {
  lineType: ExpressionSettingsLineType;
  displaySize?: RollingDisplaySize;
}

const averageOptions = [
  ExpressionSettingsLineType.Ma,
  ExpressionSettingsLineType.Ma30,
];
const sumOptions = [
  ExpressionSettingsLineType.Ms7,
  ExpressionSettingsLineType.Ms30,
];

export const getAmountFromExpressionSettingLineType = (
  lineType: ExpressionSettingsLineType,
): number | null => {
  if (
    lineType === ExpressionSettingsLineType.Ma ||
    lineType === ExpressionSettingsLineType.Ms7
  ) {
    return 7;
  }

  if (
    lineType === ExpressionSettingsLineType.Ma30 ||
    lineType === ExpressionSettingsLineType.Ms30
  ) {
    return 30;
  }

  return null;
};

export const getLineTypeLabel = (
  lineType: ExpressionSettingsLineType,
): string => {
  if (lineType === ExpressionSettingsLineType.CumulativeSum) {
    const { sign } = measureRollingControlLookup[RollingControlFunction.Sum];
    return `${sign}c.`;
  }

  const amount = getAmountFromExpressionSettingLineType(lineType);

  if (averageOptions.includes(lineType) && amount) {
    const { sign } = measureRollingControlLookup[RollingControlFunction.Avg];
    return `${sign}${amount}`;
  }

  if (sumOptions.includes(lineType) && amount) {
    const { sign } = measureRollingControlLookup[RollingControlFunction.Sum];
    return `${sign}${amount}`;
  }

  return '';
};

export default ({ lineType, displaySize = 'sm' }: IProps) => {
  if (lineType === ExpressionSettingsLineType.CumulativeSum) {
    return (
      <RollingControlDisplay
        rollingFunction={RollingControlFunction.Sum}
        value="C."
        displaySize={displaySize}
      />
    );
  }

  const amount = getAmountFromExpressionSettingLineType(lineType);

  if (averageOptions.includes(lineType) && amount) {
    return (
      <RollingControlDisplay
        rollingFunction={RollingControlFunction.Avg}
        value={amount}
        displaySize={displaySize}
      />
    );
  }

  if (sumOptions.includes(lineType) && amount) {
    return (
      <RollingControlDisplay
        rollingFunction={RollingControlFunction.Sum}
        value={amount}
        displaySize={displaySize}
      />
    );
  }

  return null;
};
